// extracted by mini-css-extract-plugin
export var avatarContainer = "_3r-1";
export var largeAvatarContainer = "_3r-2";
export var smallAvatarContainer = "_3r-0";